import qs from 'qs';

export class RoutePaths {
  static login = {
    path: 'login',
    onNavigate: () => '/login',
  };

  static recovery = {
    path: 'recovery',
    onNavigate: () => '/recovery',
  };

  static userNameRecovery = {
    path: 'username',
    onNavigate: () => '/recovery/username',
  };
  static passwordRecovery = {
    path: 'password',
    onNavigate: () => '/recovery/password',
  };

  static applyNow = {
    path: 'apply-now',
    onNavigate: () => '/apply-now',
  };

  static dashboard = {
    path: 'dashboard',
    onNavigate: () => '/dashboard',
  };

  static accounts = {
    path: 'dashboard/accounts/:id',
    onNavigate: (id: string) => `/dashboard/accounts/${id}`,
  };

  static cards = {
    path: 'dashboard/cards',
    onNavigate: () => '/dashboard/cards',
  };

  static payments = {
    path: 'dashboard/payments',
    onNavigate: () => '/dashboard/payments',
  };

  static contactUs = {
    path: 'dashboard/contact-us',
    onNavigate: () => '/dashboard/contact-us',
  };

  static messages = {
    path: 'dashboard/messages/:dir/:id?',
    onNavigate: (params: { dir: string; id?: string }, query?: { q?: string; from?: string; to?: string; queryString?: string }) => {
      const { queryString, ...rest } = query ?? {};
      const search = queryString ? queryString : qs.stringify(rest, { addQueryPrefix: true });
      return `/dashboard/messages/${params.dir}${params.id ? `/${params.id}` : ''}${search}`;
    },
  };
}
